export const messages = {
    en: {
      site_title: 'Plants4Pets',
      site_tagline: 'Check whether houseplants are toxic for cats, dogs and horses.',
      site_seo_text: 'Plants4Pets is a free database of houseplants and garden species with toxicity ratings for cats, dogs and horses. Search by common or Latin name, browse the full list page by page, and open a dedicated page for each plant with photos, alternative names and safety notes. Information is for educational use — always contact a veterinarian if your pet eats an unknown plant.',
      additional_names: 'Additional names',
      toxic: 'Toxic',
      safe: 'Safe',
      unknown: 'Unknown',
      verified: 'Verified',
      not_verified: 'Not verified',
      partially_verified: 'Partially verified',
      community_confirm: 'Confirm as correct',
      community_confirmed: 'Confirmed by you',
      community_confirmations: 'community confirmations',
      community_note: 'Community confirmations are not verified by our team.',
      check_is_plant_toxic: 'Check is plant toxic',
      filter_loved: 'Favorites',
      filter_safe: 'Safe',
      search_prompt: 'Type a plant name to search the database.',
      search_section_title: 'Search plants',
      switch_language: 'Switch language',
      footer_home: 'Home',
      report_short: 'Report',
      plant_not_found: 'Plants not found',
      try_different_query: 'Try changing search criteria or browse the full list without filters.',
      author: 'Image author',
      email: 'E-mail',
      email_placeholder: 'your@email.com',
      description: 'Description',
      description_placeholder: 'Describe the issue: plant name, pet species, what is wrong, and link to your source if you have one.',
      report_comments_title: 'Report an error or suggestion',
      send: 'Send report',
      cancel: 'Cancel',
      footer_privacy: 'Privacy policy',
      footer_terms: 'Terms',
      plant: 'Plant',
      report_missing_plant: 'Cannot find the plant you need, or spotted incorrect data?',
      report_general_plant: 'General report — describe the plant in the message below.',
      report_modal_intro: 'Use this form to help us improve Plants4Pets. The more detail you provide, the faster we can review your report.',
      report_modal_alt: 'Prefer e-mail? Write to',
      report_section_title: 'Report an error or missing plant',
      report_section_lead: 'Our database is updated thanks to user feedback. Tell us if something is wrong — we read every message.',
      report_reason_toxicity: 'Wrong toxicity rating for a cat, dog or horse',
      report_reason_missing: 'Missing plant or incorrect name',
      report_reason_photo: 'Better photo or outdated image',
      report_reason_source: 'Link to a veterinary or botanical source',
      report_open_form: 'Open report form',
      report_section_note: 'Include the plant name, affected pet species and a source link if possible. We usually reply within a few business days.',
      description_max_characters: 'Maximum 500 characters',
      error_email: 'Incorrect e-mail address',
      empty_description: 'Please describe the issue',
      empty_agreement: 'Accept the Terms and Privacy Policy to send the report',
      create_report_success: 'Thank you! Your report has been sent.',
      create_report_error: 'Could not send the report — try again or e-mail us directly.',
      write_email: 'kontakt@plants4pets.pl',
      open_plant_page: 'Open plant page',
      shopping: 'Shop',
      no_photos: 'No photos in our database yet.',
      search_google_images: 'Search photos on Google Images',
      contributor_popup_title: 'Help us build a public encyclopedia',
      contributor_popup_text: 'We are looking for <strong>biologists</strong>, <strong>veterinarians</strong> and <strong>animal lovers</strong> to verify and expand plant toxicity data. Join us and help create a free encyclopedia for everyone.',
      contributor_popup_contact: 'Get in touch',
      contributor_popup_report: 'Report data',
      contributor_popup_close: 'Close'
    },
    pl: {
      site_title: 'Plants4Pets',
      site_tagline: 'Sprawdź, czy rośliny domowe są toksyczne dla kota, psa i konia.',
      site_seo_text: 'Plants4Pets to bezpłatna baza roślin domowych i ogrodowych z oceną toksyczności dla kota, psa i konia. Wyszukaj roślinę po nazwie potocznej lub łacińskiej, przeglądaj pełną listę strona po stronie i otwieraj dedykowane karty roślin ze zdjęciami, nazwami alternatywnymi oraz wskazówkami bezpieczeństwa. Informacje mają charakter edukacyjny — w razie zjedzenia rośliny przez zwierzę skontaktuj się z weterynarzem.',
      additional_names: 'Dodatkowe nazwy',
      toxic: 'Toksyczna',
      safe: 'Bezpieczna',
      unknown: 'Nie wiadomo',
      verified: 'Zweryfikowane',
      not_verified: 'Niezweryfikowane',
      partially_verified: 'Częściowo zweryfikowane',
      community_confirm: 'Potwierdź poprawność',
      community_confirmed: 'Potwierdzone przez Ciebie',
      community_confirmations: 'społecznych potwierdzeń',
      community_note: 'Społeczne potwierdzenia nie są weryfikacją przez nasz zespół.',
      check_is_plant_toxic: 'Sprawdź toksyczność rośliny',
      filter_loved: 'Ulubione',
      filter_safe: 'Bezpieczne',
      search_prompt: 'Wpisz nazwę rośliny, aby przeszukać bazę.',
      search_section_title: 'Wyszukaj roślinę',
      switch_language: 'Zmień język',
      footer_home: 'Strona główna',
      report_short: 'Zgłoś',
      plant_not_found: 'Nie znaleziono roślin',
      try_different_query: 'Spróbuj zmienić kryteria wyszukania lub przeglądaj pełną listę bez filtrów.',
      author: 'Autor zdjęcia',
      email: 'E-mail',
      email_placeholder: 'twoj@email.pl',
      description: 'Opis zgłoszenia',
      description_placeholder: 'Opisz problem: nazwa rośliny, gatunek zwierzęcia, co jest nie tak oraz link do źródła, jeśli go masz.',
      report_comments_title: 'Zgłoś błąd lub sugestię',
      send: 'Wyślij zgłoszenie',
      cancel: 'Anuluj',
      footer_privacy: 'Polityka prywatności',
      footer_terms: 'Regulamin',
      plant: 'Roślina',
      report_missing_plant: 'Nie ma szukanej rośliny albo zauważyłeś błąd w danych?',
      report_general_plant: 'Zgłoszenie ogólne — opisz roślinę w polu poniżej.',
      report_modal_intro: 'Pomożesz nam ulepszyć Plants4Pets. Im więcej szczegółów podasz, tym szybciej zweryfikujemy zgłoszenie.',
      report_modal_alt: 'Wolisz e-mail? Napisz na',
      report_section_title: 'Zgłoś błąd lub brakującą roślinę',
      report_section_lead: 'Nasza baza jest aktualizowana dzięki zgłoszeniom użytkowników. Daj znać, jeśli coś jest nie tak — czytamy każdą wiadomość.',
      report_reason_toxicity: 'Błędna ocena toksyczności dla kota, psa lub konia',
      report_reason_missing: 'Brakująca roślina lub błędna nazwa',
      report_reason_photo: 'Lepsze zdjęcie lub nieaktualny obraz',
      report_reason_source: 'Link do źródła weterynaryjnego lub botanicznego',
      report_open_form: 'Otwórz formularz zgłoszenia',
      report_section_note: 'Podaj nazwę rośliny, gatunek zwierzęcia oraz link do źródła, jeśli możesz. Zwykle odpowiadamy w ciągu kilku dni roboczych.',
      description_max_characters: 'Maksymalnie 500 znaków',
      error_email: 'Niepoprawny adres e-mail',
      empty_description: 'Opisz problem w polu zgłoszenia',
      empty_agreement: 'Zaakceptuj Regulamin i Politykę prywatności, aby wysłać zgłoszenie',
      create_report_success: 'Dziękujemy! Zgłoszenie zostało wysłane.',
      create_report_error: 'Nie udało się wysłać zgłoszenia — spróbuj ponownie lub napisz do nas e-mailem.',
      write_email: 'kontakt@plants4pets.pl',
      open_plant_page: 'Strona rośliny',
      shopping: 'Sklep',
      no_photos: 'Brak zdjęć w naszej bazie.',
      search_google_images: 'Szukaj zdjęć w Google Images',
      contributor_popup_title: 'Pomóż budować ogólnodostępną encyklopedię',
      contributor_popup_text: 'Szukamy <strong>biologów</strong>, <strong>weterynarzy</strong> i <strong>miłośników zwierząt</strong> do weryfikacji i uzupełniania danych o toksyczności roślin. Dołącz i pomóż tworzyć bezpłatną encyklopedię dla wszystkich.',
      contributor_popup_contact: 'Napisz do nas',
      contributor_popup_report: 'Zgłoś poprawkę',
      contributor_popup_close: 'Zamknij'
    }
  }
